/* istanbul ignore file */

import styled from 'styled-components';

import { medias } from 'assets/styled/tokens';

export interface PageWrapperProps {
  background?: string;
  // Não usado no CSS deste componente — aceito por compatibilidade com um consumidor
  // (PDFOcurrence/index.tsx) que já passava essa prop antes desta conversão para TS.
  isSubMenuOpen?: boolean;
}

export const PageWrapper = styled.div<PageWrapperProps>`
  position: relative;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  background: ${props => props.background || 'transparent'};

  display: flex;

  @media screen and (max-width: ${medias.desktopSm}) {
    flex-direction: column;
  }
`;
